import React, { useEffect } from 'react';
import {
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { DialogType } from 'enum';
import { makeStyles, Theme } from '@material-ui/core/styles';
import LogUtils from 'utils/logUtils';

/***********************************************************************
 * 型定義
 ***********************************************************************/
/**
 * ダイアログコンポーネント引数
 * @name DialogComponentProp
 */
export type DialogComponentProp = {
  dialogType: DialogType;
  message: string;
  open: boolean;
  onCloseClick: () => void;
};
/***********************************************************************
 * Style
 ***********************************************************************/
/**
 * スタイル定義
 * @name useStyles
 */
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  content: {
    width: '200px',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  progress: {},
}));

/***********************************************************************
 * メイン処理
 ***********************************************************************/
/**
 * ダイアログコンポーネント
 * @name DialogComponent
 */
const DialogComponent: React.FC<DialogComponentProp> = ({
  dialogType,
  message,
  open,
  onCloseClick,
}) => {
  /**
   * クラス名
   * @name className
   * @member
   */
  const className = 'DialogComponent';
  /**
   * スタイル定義
   * @name classes
   * @member
   */
  const classes = useStyles();

  /**
   * 副作用フック
   * @name useEffect
   * @function
   */
  useEffect(() => {
    /**
     * 初期設定処理
     * @name init
     * @event
     */
    const init = async () => {
      const methodName = 'init';
      try {
        LogUtils.info(`${className} ${methodName} start`);

        LogUtils.info(`${className} ${methodName} end`);
      } catch (e) {
        LogUtils.info(`${className} ${methodName} Error: ${e}`);
      }
    };
    init();
  }, []);

  /***********************************************************************
   * 画面の定義
   ***********************************************************************/
  return (
    <div className={classes.root}>
      <Dialog aria-labelledby="customized-dialog-title" open={open}>
        <DialogContent dividers className={classes.content}>
          {dialogType === DialogType.Loading && (
            <Typography gutterBottom>{'Please wait...'}</Typography>
            // <CircularProgress className={classes.progress} />
          )}
          {dialogType === DialogType.OKOnly && (
            <Typography gutterBottom>{message}</Typography>
          )}
        </DialogContent>

        {dialogType === DialogType.OKOnly && (
          <DialogActions>
            <Button autoFocus onClick={onCloseClick} color="primary">
              Close
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

export default DialogComponent;
